import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgSystem(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "system_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#system_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M27.872 44.398l4.163 4.056L42.15 36.993",
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M42.295 45.11v10.93c0 1.05-.427 2.058-1.188 2.8a4.11 4.11 0 01-2.87 1.16H25.75a4.11 4.11 0 01-2.869-1.16 3.912 3.912 0 01-1.189-2.8V28.427c0-1.05.428-2.057 1.19-2.8a4.11 4.11 0 012.868-1.16h12.487a4.11 4.11 0 012.87 1.16 3.912 3.912 0 011.188 2.8v2.699",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M44.504 17.742C41.156 14.564 36.67 12.787 32 12.787s-9.157 1.777-12.505 4.955h-.029M52 12.084a28.34 28.34 0 00-9.176-5.983A28.892 28.892 0 0032 4c-3.714 0-7.392.714-10.824 2.101A28.34 28.34 0 0012 12.084",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgSystem;